import React from "react";
import { Col, Row } from "react-bootstrap";

export default function Detail_Ozo_Loading_Bar({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  return (
    <Row
      className={"mx-0"}
      style={{
        height: Number(item.height),
      }}
    >
      <div style={{ backgroundColor: "#fff" }}>
        {/* Sub scope name if exists */}
        {isSub && item.scopeName && (
          <Row className={"_detail-section-sub-scope-name-header-pdf mb-3"}>{item.scopeName}</Row>
        )}

        {/* Title - Centered at top */}
        <Row className="justify-content-center mb-4">
          <Col xs="auto">
            <div style={{ fontSize: "24px", fontWeight: "700", color: "#092441", textAlign: "center" }}>
              {item.name}
            </div>
          </Col>
        </Row>

        {/* Main content layout */}
        <Row className="align-items-center">
          {/* Left side text */}
          <Col xs={4}>
            <div
              className="detail-scale-general-info-text-wrap-up"
              style={{ fontSize: "12px", color: "#666", lineHeight: "1.4", textAlign: "justify" }}
              dangerouslySetInnerHTML={{ __html: item.lowSideText }}
            />
          </Col>

          {/* Center - Progress bar with percentage */}
          <Col xs={4} className="d-flex flex-column align-items-center px-0">
            <Row className={"mx-0 w-100"}>
              <Col xs={"auto"} className={"align-content-center px-2"}>
                <div className={"fw-medium lh-1"} style={{ fontSize: "16px", color: "#000" }}>
                  {elementScore}%
                </div>
              </Col>
              <Col className={"px-2"}>
                <div
                  style={{
                    borderRadius: "9px",
                    background: "linear-gradient(270deg, rgba(160, 228, 234, 0.2) 0%, rgba(0, 234, 255, 0.2) 100%)",
                  }}
                >
                  <Row className={"mx-0"} style={{ height: "18px" }}>
                    <Col
                      xs={"auto"}
                      className={"px-0"}
                      style={{
                        borderRadius: "9px",
                        minWidth: "18px",
                        width: `${elementScore}%`,
                        background: "linear-gradient(270deg, #A0E4EA 0%, #00EAFF 100%)",
                      }}
                    ></Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Col>

          {/* Right side text */}
          <Col xs={4}>
            <div
              className="detail-scale-general-info-text-wrap-up"
              style={{
                fontSize: "12px",
                color: "#666",
                lineHeight: "1.4",
                textAlign: "justify",
                textAlignLast: "right",
              }}
              dangerouslySetInnerHTML={{ __html: item.highSideText }}
            />
          </Col>
        </Row>

        {/* Bottom section - General information if available */}
        {item.generalInformationText?.length > 2 && (
          <Row className="mt-4">
            <Col>
              <div
                style={{ fontSize: "11px", color: "#999", lineHeight: "1.4", textAlign: "center" }}
                dangerouslySetInnerHTML={{ __html: item.generalInformationText }}
              />
            </Col>
          </Row>
        )}
      </div>
    </Row>
  );
}
